module.exports = __webpack_public_path__ + "img/pc-title.ea284384.webp";